import "/assets/styles/sections/home/pricing.scss";

// Partials
import Btn from '/views/partials/btn';

const Pricing = () => {
	return (
		<main
			id="pricing"
			className="section home-pricing">
			<div className="pricing-wrap wrapper">
				<h1 className="pricing-pretitle">Transparent & Flexible</h1>
				<h2 className="pricing-title">Pricing Built for Growth</h2>

				<div className="pricing-detail">
					<strong className="detail-title">
						Commission Model
					</strong>

					<div className="detail-description">
						Our platform operates on a low, competitive commission model for ticket sales and in-event transactions.
					</div>

					<ul className="detail-points">
						<li>No monthly maintenance fees.</li>
						<li>Volume discounts available.</li>
						<li>Dedicated support included.</li>
					</ul>

					<div className="detail-controls">
						<Btn
							tag="a"
							href="#contact"
							className="detail-cta primary nude"
							afterIcon="arrow-right">
							Contact us for a custom quote
						</Btn>
					</div>

				</div>
			</div>
		</main>
	);
};

export default Pricing;
